import { Card, Divider, message } from "antd";
import { CopyOutlined } from "@ant-design/icons";
import { useBuscarLead } from "../hooks/useBuscarLead";
import { useBuscarPostagem } from "../hooks/useBuscarPostagem";
import {
  ContainerModal,
  ItemTextModal,
  ItemWrapper,
  TextModal,
  Title,
} from "../styles";
import { formatPhoneNumber } from "../../../uteis/formatPhoneNumber";

export default function ModalPostagem({
  id,
  isOpen,
}: {
  id: number;
  isOpen: boolean;
}) {
  const { postagem, isLoading } = useBuscarPostagem(id, isOpen);
  const leadId = postagem?.idLeads;

  const { lead, isLoading: isLoadingLead } = useBuscarLead(
    leadId,
    isOpen && !!leadId
  );

  if (isLoading || isLoadingLead) {
    return <p>{"Carregando Informa\u00e7\u00f5es..."}</p>;
  }

  if (!postagem || !lead) {
    return (
      <p>
        {"Nenhuma informa\u00e7\u00e3o de contato encontrada para esta postagem."}
      </p>
    );
  }

  return (
    <Card
      title={<Title>{"Informa\u00e7\u00f5es da Postagem"}</Title>}
      style={{
        width: "100%",
        marginTop: "20px",
        borderRadius: "10px",
        boxShadow: "0px 4px 10px rgba(0, 0, 0, 0.1)",
      }}
    >
      <ContainerModal>
        {[
          {
            label: "Nome do Lead",
            value: lead?.nome,
          },
          {
            label: "Tipo Lead",
            value: lead?.tipo,
          },
          {
            label: "Celular",
            value: (
              <>
                {formatPhoneNumber(lead?.celular ?? "")}
                <CopyOutlined
                  onClick={() => {
                    if (lead?.celular) {
                      navigator.clipboard.writeText(lead.celular);
                      message.success(
                        "N\u00famero copiado para a \u00e1rea de transfer\u00eancia!"
                      );
                    }
                  }}
                  style={{
                    marginLeft: 8,
                    cursor: "pointer",
                    color: "#1677ff",
                  }}
                />
              </>
            ),
          },
        ].map((item, index) => (
          <ItemWrapper key={index}>
            <ItemTextModal>{item.label}</ItemTextModal>
            <TextModal>{item.value}</TextModal>
            {index < 8 && <Divider />}
          </ItemWrapper>
        ))}
      </ContainerModal>
    </Card>
  );
}
